var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("产品信息")))])]), _c("a-form-model", {
    attrs: {
      model: _vm.form,
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 18
      }
    }
  }, [_c("a-row", [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("产品名称")
    }
  }, [_vm._v(_vm._s(_vm.form.name.name || "-"))])], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("发布客户")
    }
  }, [_vm._v(_vm._s(_vm.form.customerName))])], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("保险公司")
    }
  }, [_vm._v(_vm._s(_vm.form.unitName))])], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("客户应用")
    }
  }, [_vm._v(_vm._s(_vm.form.applicationName))])], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("承保年龄")
    }
  }, [_vm._v(_vm._s(_vm.form.age))])], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("险种分类")
    }
  }, [_vm._v(_vm._s(_vm.form.classificationName) + "(" + _vm._s(_vm.form.labelName) + ")")])], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("保障期限")
    }
  }, [_vm._v(_vm._s(_vm.form.duration))])], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("保障额度")
    }
  }, [_vm._v(_vm._s(_vm.form.amount))])], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("承保区域")
    }
  }, [_vm._v(_vm._s(_vm.form.area))])], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("承保职业")
    }
  }, [_vm._v(_vm._s(_vm.form.occupation))])], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("等待期（天）")
    }
  }, [_vm._v(_vm._s(_vm.form.wait))])], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("犹豫期（天）")
    }
  }, [_vm._v(_vm._s(_vm.form.hesitate))])], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("支付方式")
    }
  }, [_vm._v(_vm._s(_vm.form.payMethodName))])], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("生效日")
    }
  }, [_vm._v(_vm._s(_vm.form.effective))])], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("投保份数")
    }
  }, [_vm._v(_vm._s(_vm.form.servings))])], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("出单模式")
    }
  }, [_vm._v(_vm._s(_vm.form.isTimely == 0 ? _vm.$t("非实时出单") : _vm.$t("实时出单")))])], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("产品方案模版")
    }
  }, [_c("a-button", {
    attrs: {
      type: "link"
    },
    on: {
      click: _vm.downloadFun
    }
  }, [_vm._v(_vm._s(_vm.$t("下载")))])], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("附加险")
    }
  }, [_c("a-button", {
    attrs: {
      type: "link"
    },
    on: {
      click: _vm.seeAdditionalFun
    }
  }, [_vm._v(_vm._s(_vm.$t("查看")))])], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("投保提醒")
    }
  }, [_vm._v(_vm._s(_vm.form.reminder.name))])], 1)], 1)], 1), _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("文案信息")))])]), _c("a-form-model", {
    attrs: {
      model: _vm.form,
      "label-col": {
        span: 3
      },
      "wrapper-col": {
        span: 18
      }
    }
  }, [_c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("保险特点")
    }
  }, [_vm._v(_vm._s(_vm.form.feature.name || ""))])], 1), _c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("保障权益")
    }
  }, _vm._l(_vm.form.rights, function (item, index) {
    return _c("div", {
      key: index
    }, [_vm._v(_vm._s(item.info) + "-" + _vm._s(item.name) + "-" + _vm._s(item.value))]);
  }), 0)], 1), _vm._l(_vm.form.copywriting, function (item, index) {
    return _c("a-col", {
      key: index,
      attrs: {
        span: 24
      }
    }, [_c("a-form-model-item", {
      attrs: {
        label: item.name
      }
    }, [_c("quill-editor", {
      ref: "myTextEditor",
      refInFor: true,
      staticStyle: {
        height: "400px",
        "margin-bottom": "20px"
      },
      attrs: {
        options: _vm.quillOption,
        disabled: !item.isEdit
      },
      model: {
        value: item.content,
        callback: function ($$v) {
          _vm.$set(item, "content", $$v);
        },
        expression: "item.content"
      }
    })], 1)], 1);
  })], 2), _vm.type == 1 ? _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("审核")))])]) : _vm._e(), _vm.type == 1 ? _c("a-form-model", {
    attrs: {
      model: _vm.form,
      "label-col": {
        span: 3
      },
      "wrapper-col": {
        span: 18
      }
    }
  }, [_c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("审核意见")
    }
  }, [_c("a-textarea", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("审核意见"),
      "auto-size": {
        minRows: 5,
        maxRows: 10
      }
    },
    model: {
      value: _vm.dataFrom.content,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "content", $$v);
      },
      expression: "dataFrom.content"
    }
  })], 1)], 1), _c("a-col", {
    staticClass: "marginT20",
    staticStyle: {
      "padding-bottom": "100px"
    },
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    attrs: {
      "wrapper-col": {
        span: 10,
        offset: 8
      }
    }
  }, [_c("a-button", {
    attrs: {
      type: "danger"
    },
    on: {
      click: function ($event) {
        return _vm.onSubmit(4);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("驳回")))]), _c("a-button", {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      type: "primary"
    },
    on: {
      click: function ($event) {
        return _vm.onSubmit(3);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("审核通过")))])], 1)], 1)], 1) : _vm._e(), _vm.templateShow ? _c("plan-template-model", {
    ref: "templateFrom",
    on: {
      cancel: function ($event) {
        _vm.templateShow = false;
      }
    }
  }) : _vm._e(), _vm.additionalShow ? _c("additional-model", {
    ref: "additionalFrom",
    on: {
      cancel: function ($event) {
        _vm.additionalShow = false;
      }
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };